import React from 'react';

const LegalMentions = () => {
    return (
        <div className="container" style={{ padding: '60px 20px' }}>
            <h1>MENTIONS LÉGALES</h1>

            <section className="section text-left">
                <h2>1. ÉDITEUR DU SITE</h2>
                <p>
                    Le présent site internet est édité par : <strong>Help Mind Formation</strong>
                    <br />
                    <strong>Responsable de la publication :</strong> Cathy [Nom de famille à compléter]
                    <br />
                    <strong>Adresse :</strong> [Adresse postale à compléter]
                    <br />
                    <strong>Téléphone :</strong> 06 11 03 93 84
                    <br />
                    <strong>Email :</strong> cathy@helpmindformation.fr
                    <br />
                    <strong>SIRET :</strong> [Numéro SIRET à compléter]
                </p>
            </section>

            <section className="section text-left">
                <h2>2. HÉBERGEMENT</h2>
                <p>
                    Ce site est hébergé par :
                    <br />
                    <strong>OVH</strong>
                    <br />
                    2, rue Kellermann, 59100 Roubaix, France
                    <br />
                    +33 9 72 10 10 07
                </p>
            </section>

            <section className="section text-left">
                <h2>3. PROPRIÉTÉ INTELLECTUELLE</h2>
                <p>
                    L’ensemble des contenus présents sur ce site (textes, images, logos, graphismes) est la propriété exclusive de <strong>Help Mind Formation</strong> ou de ses partenaires. Toute reproduction, distribution, modification, adaptation, retransmission ou publication, même partielle, de ces différents éléments est strictement interdite sans l’accord exprès par écrit de Help Mind Formation.
                </p>
            </section>

            <section className="section text-left">
                <h2>4. DONNÉES PERSONNELLES</h2>
                <p>
                    Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d’un droit d’accès, de rectification et de suppression des données vous concernant.
                </p>
                <p>
                    Les données collectées via le formulaire de contact sont utilisées uniquement dans le cadre de la gestion de votre demande et de la relation commerciale qui peut en découler. Elles ne sont en aucun cas transmises à des tiers sans votre consentement.
                </p>
                <p>
                    Pour exercer ces droits, vous pouvez nous contacter par email à : <strong>cathy@helpmindformation.fr</strong>
                </p>
            </section>

            <section className="section text-left">
                <h2>5. RESPONSABILITÉ</h2>
                <p>
                    Help Mind Formation s’efforce de fournir sur ce site des informations aussi précises que possible. Toutefois, l'organisme ne saurait être tenu responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu’elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.
                </p>
            </section>
        </div>
    );
};

export default LegalMentions;
